import { Controller } from "@hotwired/stimulus"

// Validates file size before upload
export default class extends Controller {
  static targets = ["input", "error"]
  static values = {
    maxSize: { type: Number, default: 8 }, // Size in MB
  }

  connect() {
    this.clearError()
  }

  validate(event) {
    const files = event.target.files
    const maxSizeBytes = this.maxSizeValue * 1024 * 1024 // Convert MB to bytes

    for (let i = 0; i < files.length; i++) {
      if (files[i].size > maxSizeBytes) {
        event.preventDefault()
        this.showError(`File "${files[i].name}" is too large. Maximum size is ${this.maxSizeValue}MB.`)
        event.target.value = '' // Clear the input
        return
      }
    }

    this.clearError()
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove('hidden')
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ''
      this.errorTarget.classList.add('hidden')
    }
  }
}
